import { render, staticRenderFns } from "./Speech.vue?vue&type=template&id=16d93b4a&scoped=true&"
import script from "./Speech.vue?vue&type=script&lang=js&"
export * from "./Speech.vue?vue&type=script&lang=js&"
import style0 from "./Speech.vue?vue&type=style&index=0&id=16d93b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d93b4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
